import React, { useState, useEffect } from "react";
import HeaderLeft from "./HeaderLeft";
import zipimg from "../assets/images/zip.png";
import { Link, useLocation } from "react-router-dom";
import DownloadLink from "react-download-link";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { SpinnerCircular } from "spinners-react";

function DownloadSampleEvo(props) {
  let user = localStorage.getItem("user");
  user = JSON.parse(user);
  const [loading, setLoading] = useState(true);
  const [sapmeEvoVideo, setSapmeEvoVideo] = useState([]);
  const [index, setindex] = useState(0);
  const [error, setError] = useState("");
  const token = GetStorage.get("xAuthToken");
  const location = useLocation();
  const { zip } = location.state;

  // useEffect(() => {
  //   DownloadSampleEvoVideo();
  // }, []);

  // const DownloadSampleEvoVideo = async () => {
  //   setLoading(true);

  //   http
  //     .get(`api/category?token=${token}`)
  //     .then((res) => {
  //       console.log("response evo =======>", res.data);
  //       setSapmeEvoVideo(res.data);
  //       setindex(Math.floor(Math.random() * res.data.length - 1));
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setLoading(false);

  //       console.log("error ", error.response.data.errors);
  //       if (error.response) {
  //         if (error.response.data.errors) {
  //           for (let key in error.response.data.errors) {
  //             setError(error.response.data.errors[key]);
  //           }
  //         } else if (error.response.data.message) {
  //           setError(error.response.data.message);
  //         }
  //       }
  //     });
  // };

  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section class="otp_verification custom_hight">
        <div class="login_inner">
          <h1 class="mb_30 main_title ">
            {" "}
            {user.data.firstname} {user.data.lastname}
          </h1>
          <p class="mb_40 them_para text-center mx-auto text_limit">
            Please download a sample raw file, and a sample eVO, done previously
            by Argo analyst
          </p>
          <h6 class="sub_title mb_30">Step 2: Download Sample eVO</h6>

          <div class="login_inner">
            <div class="uplode_file_show">
              {" "}
              <a
                style={{ padding: 15 }}
                // className="them_btn mt_40 mb_30"
                href={zip}
                download
              >
                <img src={zipimg} alt="" />{" "}
              </a>
            </div>
            <p class="text-show-file">
              {" "}
              {zip.split("/")[zip.split("/").length - 1]}
            </p>

            <a
              style={{ padding: 15 }}
              className="them_btn mt_40 mb_30"
              href={zip}
              download
            >
              Download evo
            </a>

            <Link to="/ploadPracticeVideos">
              <button
                className="them_btn mt_40 mb_30"
                style={{ marginLeft: 20 }}
              >
                Next
              </button>
            </Link>
          </div>
          {/*  <div className="vedio">
                  <img src={zipimg} alt=""></img>
                 <video
                    src={sapmeEvoVideo[index].video}
                    style={{ width: 400 }}
                    controls
                    download
                  />{" "} 
                </div> */}
          {/* <p class="text-show-file">{sapmeEvoVideo[index].name}</p> */}
          <div className="btn_wraper">
            {/*    <a
                    style={{ padding: 15 }}
                    className="them_btn mt_40 mb_30"
                    href={sapmeEvoVideo[index].video}
                    download
                  >
                    Download rawclip
                  </a> */}
            {/*  <DownloadLink
        style={{ height: 150 }}
        className="them_btn mt_40 mb_30"
        label="Download rawclip"
        filename="https://argo-voice.s3.amazonaws.com/analyst-videos/CAM33_VIDOE44.mp4"
        exportFile={() => "My cached data"}
      /> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default DownloadSampleEvo;
